import { FORECAST_PRESET_ORDER, ForecastPreset } from "consts";

import { formatSigned } from "pages/app/scenario-analysis/utils/comparisonFormatting";

export type PresetPctTable = Record<ForecastPreset, number>;

/** Signed percentage the preset writes back to `ScenarioSettings`. */
export const pctFromPreset = (preset: ForecastPreset, table: PresetPctTable): number => table[preset];

/** Preset matching the stored percentage, or null when the drawer set a value no preset covers. */
export const presetFromPct = (pct: number, table: PresetPctTable): ForecastPreset | null =>
  FORECAST_PRESET_ORDER.find((preset) => table[preset] === pct) ?? null;

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Display name of a preset, e.g. "Neutral". */
export const presetLabel = (preset: ForecastPreset, t: Translate): string => t(`forecastSettingsBar.preset.${preset}`);

/** Label for a drawer-set percentage no preset covers, e.g. "Custom (+5%)". */
export const customPresetLabel = (pct: number, t: Translate): string => t("forecastSettingsBar.preset.custom", { value: formatSigned(pct) });

/** Label a stored percentage reads as: its preset's name, else the custom label. */
export const presetPctLabel = (pct: number, table: PresetPctTable, t: Translate): string => {
  const preset = presetFromPct(pct, table);
  return preset ? presetLabel(preset, t) : customPresetLabel(pct, t);
};
